import React, { useEffect, useState } from 'react'
import AdxToolTip from 'components/custom/AdxToolTip'
import filterApprovers from 'pages/approval-center/util/filterApprover'

const ClaimProgressTooltip = ({ data, children }) => {
  const [message, setMessage] = useState('')
  const [rejected, setRejected] = useState(false)

  // set the message
  useEffect(() => {
    if (data.status === 'rejected') {
      setRejected(true)
    }

    const namesConstructor = (arr) => {
      if (!Array.isArray(arr)) {
        return arr
      } else if (arr.length === 2 && Array.isArray(arr)) {
        return `${arr[0]} or ${arr[1]}`
      } else if (arr.length > 2 && Array.isArray(arr)) {
        return `${arr[0]} or ${arr.length - 1} others`
      } else {
        return arr
      }
    }

    if (rejected) {
      setMessage(`Waiting resubmission by ${namesConstructor(data?.members)}`)
    } else {
      setMessage(`${data?.status} by ${namesConstructor(data?.members)}`)
    }
  }, [data])

  return (
    <AdxToolTip
      title={message}
      PopperProps={{
        sx: {
          width: 150,
        },
      }}
    >
      {children}
    </AdxToolTip>
  )
}

export default ClaimProgressTooltip
